import api_base from '@/api/base';

export interface Todo {
  id: string;  // UUID string
  title: string;
  description?: string;
  is_completed: boolean;
  created_at: number;  // Unix timestamp
  completed_at?: number | null;  // Unix timestamp
  updated_at?: number;  // Unix timestamp
}

export interface CreateTodoRequest {
  title: string;
  description?: string;
}

export interface UpdateTodoRequest {
  title?: string;
  description?: string;
  is_completed?: boolean;
}

/**
 * Get all todos (active and recently completed within 24h)
 */
export const get_todos = async (): Promise<Todo[]> => {
  const response = await api_base.get('/api/v1/todos/');
  return response.data;
};

/**
 * Get only active (not completed) todos
 */
export const get_active_todos = async (): Promise<Todo[]> => {
  const response = await api_base.get('/api/v1/todos/active');
  return response.data;
};

/**
 * Get recently completed todos (completed within last 24 hours)
 */
export const get_completed_recent = async (): Promise<Todo[]> => {
  const response = await api_base.get('/api/v1/todos/completed-recent');
  return response.data;
};

/**
 * Get a single todo by ID
 */
export const get_todo = async (id: string): Promise<Todo> => {
  const response = await api_base.get(`/api/v1/todos/${id}/`);
  return response.data;
};

/**
 * Create a new todo
 * @throws {AxiosError} 400 error if user already has 10 active tasks
 */
export const create_todo = async (data: CreateTodoRequest): Promise<Todo> => {
  const response = await api_base.post('/api/v1/todos/create', data);
  return response.data;
};

/**
 * Update an existing todo (e.g., mark as complete/incomplete, update title/description)
 */
export const update_todo = async (id: string, data: UpdateTodoRequest): Promise<Todo> => {
  const response = await api_base.patch(`/api/v1/todos/${id}/update`, data);
  return response.data;
};

/**
 * Delete a todo
 */
export const delete_todo = async (id: string): Promise<void> => {
  await api_base.delete(`/api/v1/todos/${id}/delete`);
};
